document.addEventListener("DOMContentLoaded", () => {

  // -----------------------------------
  // UNIQUE PRODUCT KEY
  // -----------------------------------

  const productKey =
    "hiddenVariants_" + window.location.pathname;

  // -----------------------------------
  // VARIANT FIELDSETS
  // -----------------------------------

  const fieldsets = document.querySelectorAll(
    "variant-radios fieldset, variant-selects fieldset"
  );

  fieldsets.forEach((fieldset, fieldsetIndex) => {

    const legendText =
      fieldset.querySelector("legend")
        ?.textContent
        .trim()
        .toLowerCase() || "";

    // Skip Style Variant
    if (legendText.includes("style")) return;

    const labels = [
      ...fieldset.querySelectorAll("label")
    ];

    // Skip if variants are 3 or less
    if (labels.length <= 3) return;

    // Remove old faded classes
    labels.forEach(label => {

      label.classList.remove("variant-faded");

    });

    // -----------------------------------
    // LOAD SAVED HIDDEN VARIANTS
    // -----------------------------------

    let savedHidden =
      JSON.parse(
        localStorage.getItem(productKey)
      ) || {};

    // Generate random only once
    if (!savedHidden[fieldsetIndex]) {

      const shuffled =
        [...labels].sort(
          () => Math.random() - 0.5
        );

      // Keep 3 visible
      const visibleVariants =
        shuffled.slice(0, 3);

      // Save hidden indexes
      savedHidden[fieldsetIndex] =
        labels
          .map((label, index) =>
            !visibleVariants.includes(label)
              ? index
              : null
          )
          .filter(index => index !== null);

      localStorage.setItem(
        productKey,
        JSON.stringify(savedHidden)
      );
    }

    // -----------------------------------
    // APPLY FADED EFFECT
    // -----------------------------------

    labels.forEach((label, index) => {

      if (
        savedHidden[fieldsetIndex]
          .includes(index)
      ) {

        label.classList.add(
          "variant-faded"
        );

        // Mark input unavailable
        const inputId =
          label.getAttribute("for");

        if (inputId) {

          const input =
            document.getElementById(
              inputId
            );

          if (input) {

            input.dataset.makeToOrder =
              "true";

          }
        }
      }

    });

  });

  // -----------------------------------
  // BUTTON SELECTORS
  // -----------------------------------

  function getAddToCartButton() {

    return document.querySelector(
      'button[name="add"], .product-form__submit'
    );
  }

  function getPaymentButton() {

    return document.querySelector(
      ".shopify-payment-button"
    );
  }

  // -----------------------------------
  // UPDATE BUTTONS
  // -----------------------------------

  function updateButtons() {

    const selectedInput =
      document.querySelector(
        'input[type="radio"]:checked'
      );

    const isUnavailable =
      selectedInput &&
      selectedInput.dataset
        .makeToOrder === "true";

    const addToCartBtn =
      getAddToCartButton();

    const paymentBtn =
      getPaymentButton();

    // UNAVAILABLE VARIANT
    if (isUnavailable) {

      // Hide Buttons
      if (addToCartBtn) {

        addToCartBtn.style.display =
          "none";

      }

      if (paymentBtn) {

        paymentBtn.style.display =
          "none";

      }

    }

    // AVAILABLE VARIANT
    else {

      // Show Buttons
      if (addToCartBtn) {

        addToCartBtn.style.display =
          "";

      }

      if (paymentBtn) {

        paymentBtn.style.display =
          "";

      }

    }

  }

  // -----------------------------------
  // INITIAL CHECK
  // -----------------------------------

  setTimeout(
    updateButtons,
    500
  );

  // -----------------------------------
  // VARIANT CHANGE LISTENER
  // -----------------------------------

  document.addEventListener(
    "change",
    function(e) {

      if (
        e.target.matches(
          'input[type="radio"]'
        )
      ) {

        setTimeout(
          updateButtons,
          100
        );

      }

    }
  );

});

//stair-rugs changes
